exports.HOME = "/";
exports.ARCHIVE = "/archive/";
exports.ABOUT = "/about/";
exports.PROGRAM = "/program/";
exports.CONTACTS = "/contacts/";
exports.FAQ = "/faq/";
exports.NOT_FOUND = "/404/";
